// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1z45F","title":"AfterImages45_title__2Wfb_","images":"AfterImages45_images__1LGmj"};